import { useState } from 'react';
import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import authHeader from '../config/authHeader';

const useFetchPersonnels = () => {
    const { token, logout } = useAuth();

    const [personnels, setPersonnels] = useState([]);
    const [personnel, setPersonnel] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPersonnels = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getPersonnels`, {
                method: 'GET',
                headers: authHeader(),
            });

            if (response.status === 401) return logout();
            if (!response.ok) throw new Error('Erreur réseau lors de la récupération des Personnels');

            const data = await response.json();
            setPersonnels(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };


    const fetchPersonnelByUUID = async (uuid) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getPersonnelByUUID?uuid=${uuid}`, {
                method: 'GET',
                headers: authHeader(),
            });

            if (response.status === 401) {
                logout();
                return null;
            }

            if (!response.ok) {
                throw new Error('Erreur réseau lors de la récupération du personnel par UUID');
            }

            const data = await response.json();
            setPersonnel(data);
            return data;
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const createPersonnel = async (Data) => {
        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append("personnelPayload", JSON.stringify(Data));

        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_createPersonnel`, {
                method: 'POST',
                headers: authHeader(),
                body: formData,
            });

            if (response.status === 401) {
                logout();
                return null;
            }

            if (!response.ok) {
                throw new Error('Erreur réseau lors de la création du personnel');
            }

            const data = await response.json();
            return data;
        } catch (err) {
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    const fetchUpdatePersonnel = async (Data) => {
        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append("personnelPayload", JSON.stringify(Data));

        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_updatePersonnel`, {
                method: 'POST',
                headers: authHeader(),
                body: formData,
            });

            if (response.status === 401) {
                logout();
                return null;
            }

            if (!response.ok) {
                const message = `Erreur (${response.status}) lors de la mise à jour du personnel`;

                const err = new Error(message);
                err.status = response.status;

                throw err;
            }

            const data = await response.json();
            return data;
        } catch (err) {
            setError(err.message);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        personnels,
        fetchPersonnels,
        personnel,
        fetchPersonnelByUUID,
        fetchUpdatePersonnel,
        createPersonnel,
        loading,
        error
    };
}
export default useFetchPersonnels;